import * as jsxRuntime from "C:\\Users\\Eriksen\\VSCodeProjects\\Ei.DO\\82-eido-3.0-bakkebyen\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment